jQuery ($) ->

# Copy mailing address to billing address
    $('.copy_billing_address a').click ->
        $('#billing_address1').val($('#address1').val())
        $('#billing_address2').val($('#address2').val())
        $('#billing_address3').val($('#address3').val())
        $('#billing_address4').val($('#address4').val())
        $('#billing_state').val($('#state').val())
        $('#billing_postcode').val($('#postcode').val())
        $('#billing_country_id').val($('#country_id').val())
        return false

    $('.copy_billing_address').removeClass('hidden')
